import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BookmarkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bookmark"}/>
}
